export const selector = (state) => state.get('flashMessage');
